"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var closest_1 = require("./closest");
exports.closest = closest_1.default;
var delegate_1 = require("./delegate");
exports.delegate = delegate_1.default;
var dispatch_1 = require("./dispatch");
exports.dispatch = dispatch_1.default;
var get_attributes_1 = require("./get-attributes");
exports.getAttributes = get_attributes_1.default;
var matches_1 = require("./matches");
exports.matches = matches_1.default;
var parents_1 = require("./parents");
exports.parents = parents_1.default;
var parse_url_1 = require("./parse-url");
exports.parseUrl = parse_url_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@aws-amplify/analytics/lib/vendor/dom-utils/index.js
// module id = 487
// module chunks = 0